import { Allergen } from '../types'

// Official EU 14 allergens (Regulation EU No 1169/2011)
export const ALLERGENS: Allergen[] = [
  {
    id: 'gluten',
    name: 'Gluten',
    nameDE: 'Glutenhaltiges Getreide',
    keywords: [
      'weizen',
      'roggen',
      'gerste',
      'hafer',
      'dinkel',
      'kamut',
      'gluten',
      'mehl',
      'wheat',
      'rye',
      'barley',
      'oat',
      'spelt',
      'gries',
      'grieß',
      'malz',
      'weizenmehl',
      'roggenmehl',
      'gerstenmehl',
      'hafermehl',
      'dinkelmehl',
    ],
  },
  {
    id: 'crustaceans',
    name: 'Crustaceans',
    nameDE: 'Krebstiere',
    keywords: [
      'krebs',
      'krebstiere',
      'krabbe',
      'krabben',
      'garnele',
      'garnelen',
      'shrimp',
      'shrimps',
      'hummer',
      'lobster',
      'languste',
      'crevette',
    ],
  },
  {
    id: 'eggs',
    name: 'Eggs',
    nameDE: 'Eier',
    keywords: [
      '\\bei\\b',
      '\\beier\\b',
      '\\begg\\b',
      '\\beggs\\b',
      'eigelb',
      'eiweiß',
      'eiweiss',
      'eiklar',
      'vollei',
      'hühnerei',
      'eipulver',
      'eiprodukt',
    ],
  },
  {
    id: 'fish',
    name: 'Fish',
    nameDE: 'Fisch',
    keywords: [
      'fisch',
      'fish',
      'lachs',
      'salmon',
      'thunfisch',
      'tuna',
      'forelle',
      'kabeljau',
      'fischgelatine',
      'fischleim',
      'anchovi',
      'sardine',
      'hering',
    ],
  },
  {
    id: 'peanuts',
    name: 'Peanuts',
    nameDE: 'Erdnüsse',
    keywords: [
      'erdnuss',
      'erdnüsse',
      'peanut',
      'erdnussbutter',
      'erdnussöl',
      'erdnussol',
      'peanutbutter',
    ],
  },
  {
    id: 'soybeans',
    name: 'Soybeans',
    nameDE: 'Soja',
    keywords: [
      'soja',
      'soy',
      'tofu',
      'sojasoße',
      'sojasauce',
      'sojalecithin',
      'e322',
      'sojaprotein',
      'sojabohne',
      'sojaöl',
      'sojaol',
      'edamame',
    ],
  },
  {
    id: 'milk',
    name: 'Milk',
    nameDE: 'Milch und Laktose',
    keywords: [
      '\\bmilch\\b',
      '\\bmilk\\b',
      'laktose',
      'lactose',
      'butter',
      'käse',
      'kaese',
      'cheese',
      'sahne',
      'cream',
      'joghurt',
      'yogurt',
      'quark',
      'molke',
      'whey',
      'buttermilch',
      'rahm',
      'creme',
    ],
  },
  {
    id: 'nuts',
    name: 'Nuts',
    nameDE: 'Schalenfrüchte',
    keywords: [
      'mandel',
      'mandeln',
      'almond',
      'haselnuss',
      'haselnüsse',
      'hazelnut',
      'walnuss',
      'walnüsse',
      'walnut',
      'cashew',
      'cashews',
      'pekannuss',
      'pekannüsse',
      'pecan',
      'paranuss',
      'paranüsse',
      'macadamia',
      'pistazie',
      'pistazien',
      'pistachio',
      '\\bnuss\\b',
      '\\bnüsse\\b',
      '\\bnut\\b',
      '\\bnuts\\b',
      'baumnuss',
      'baumnüsse',
    ],
  },
  {
    id: 'celery',
    name: 'Celery',
    nameDE: 'Sellerie',
    keywords: [
      'sellerie',
      'celery',
      'staudensellerie',
      'knollensellerie',
      'selleriesalz',
      'celeriac',
    ],
  },
  {
    id: 'mustard',
    name: 'Mustard',
    nameDE: 'Senf',
    keywords: [
      'senf',
      'mustard',
      'senfkörner',
      'senfkorn',
      'senfpulver',
      'senfmehl',
      'mostrich',
    ],
  },
  {
    id: 'sesame',
    name: 'Sesame',
    nameDE: 'Sesamsamen',
    keywords: [
      'sesam',
      'sesame',
      'sesamöl',
      'sesamol',
      'sesamsamen',
      'tahini',
      'tahin',
    ],
  },
  {
    id: 'sulphites',
    name: 'Sulphites',
    nameDE: 'Schwefeldioxid und Sulfite',
    keywords: [
      'sulfit',
      'sulfite',
      'schwefeldioxid',
      'sulphur',
      'schwefel',
      'e220',
      'e221',
      'e222',
      'e223',
      'e224',
      'e226',
      'e227',
      'e228',
    ],
  },
  {
    id: 'lupin',
    name: 'Lupin',
    nameDE: 'Lupinen',
    keywords: ['lupine', 'lupinen', 'lupin', 'lupinenmehl', 'lupinenprotein'],
  },
  {
    id: 'molluscs',
    name: 'Molluscs',
    nameDE: 'Weichtiere',
    keywords: [
      'muschel',
      'muscheln',
      'mussel',
      'schnecke',
      'schnecken',
      'snail',
      'tintenfisch',
      'squid',
      'oktopus',
      'octopus',
      'auster',
      'austern',
      'oyster',
      'weichtier',
      'weichtiere',
      'kalmar',
      'sepia',
    ],
  },
]

export function detectAllergens(ingredientName: string): string[] {
  const nameLower = ingredientName.toLowerCase()
  const detectedAllergens: string[] = []

  ALLERGENS.forEach((allergen) => {
    const hasMatch = allergen.keywords.some((keyword) => {
      // Check if keyword is a regex pattern (starts with \b)
      if (keyword.startsWith('\\b')) {
        try {
          const regex = new RegExp(keyword, 'i')
          return regex.test(nameLower)
        } catch {
          return false
        }
      }
      // Otherwise use simple substring matching
      return nameLower.includes(keyword.toLowerCase())
    })

    if (hasMatch) {
      detectedAllergens.push(allergen.id)
    }
  })

  return detectedAllergens
}

export function getAllergenById(id: string): Allergen | undefined {
  return ALLERGENS.find((a) => a.id === id)
}
